<template>
  <div>
    <div class="row cards">
      <div class="col-md-3 card" v-for="(formulario, index) in getFormularios" :key="index">
        <span style="max-width: 158px;">{{ formulario.area.nome }}</span>
        <div class="actions">
          <a  :href="`/sie/registro-etapa2/mtse/cod_doc/${formulario.cod_formularios_mtse}`" 
              v-if="formulario.cod_formularios_mtse"
              download>
            <i
              class="fa fa-print"
              title="Imprimir"
            ></i>
          </a>
          <i
            :class="`fa ${isReadonly ? 'fa-eye' : 'fa-edit'} cursor-pointer`"
            title="Editar"
            @click="onEditFormClick(formulario)"
          ></i>
          <i
            class="fa fa-trash"
            title="Apagar"
            @click="onRemoveFormClick(formulario)"
            v-if="!isReadonly && !formulario.cod_formularios_mtse"
          ></i>
        </div>
      </div>
    </div>
    <button
      type="button"
      class="btn"
      @click="onAddFormClick"
      v-if="!isReadonly && getFormularios < 1"
    >Incluir novo formulário</button>

    <mtse-modal
      :show="activeIndex !== null"
      :value="activeIndex !== null ? formularios[activeIndex] : null"
      :areas="areas"
      :categorias="categorias"
      :unidades-medida="unidadesMedida"
      :isReadonly="isReadonly"
      @onClose="closeModal"
      @change="onChangeForm"
    ></mtse-modal>

    <input type="hidden" name="mtse_forms" :value="JSON.stringify(formularios)" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    categorias: {
      required: true
    },
    unidadesMedida: {
      required: true
    },
    areas: {
      required: true
    },
    isReadonly: {
      required: true
    }
  },
  data: () => ({
    formularios: [],
    activeIndex: null
  }),
  computed: {
    getFormularios() {
      return this.formularios.filter(form => !form.deleted);
    }
  },
  watch: {
    activeIndex: function(val) {
      if (val !== null) {
        if (this.isReadonly) {
          setTimeout(() => {
            this.$el
              .querySelectorAll(".add-item-table-component .form-fields")
              .forEach(node => {
                node.style.setProperty("display", "none", "important");
              });
            this.$el
              .querySelectorAll(".add-item-table-component .btn-add")
              .forEach(node => {
                node.style.setProperty("display", "none", "important");
              });
            this.$el.querySelectorAll(".table-actions").forEach(node => {
              node.style.setProperty("display", "none", "important");
            });
            this.$el.querySelectorAll(".form-control").forEach(control => {
              control.setAttribute("readonly", true);
            });
          }, 100);
        } else {
          setTimeout(() => {
            this.$el
              .querySelectorAll(".add-item-table-component .form-fields")
              .forEach(node => {
                node.removeAttribute("style");
              });
            this.$el
              .querySelectorAll(".add-item-table-component .btn-add")
              .forEach(node => {
                node.removeAttribute("style");
              });
            this.$el.querySelectorAll(".table-actions").forEach(node => {
              node.removeAttribute("style");
            });
            this.$el.querySelectorAll(".form-control").forEach(control => {
              if(!control.classList.contains("readonly")) {
                control.removeAttribute("readonly");
              }
            });
          }, 100);
        }
      }
    }
  },
  methods: {
    onAddFormClick() {
      const formObj = {
        cod_formularios_mtse: null,
        _id: Math.random()
          .toString(36)
          .substr(2, 9), // used when not saved
        area: {
          cod_area: null,
          nome_area: "ovo"
        },
        capacidade_maxima_op_list: [],
        terreno: {
          area_total_terreno: 0,
          area_a_construir: 0,
          area_util: 0,
          recuo_alinhamento_rua: 0,
          delimitacao_perimetro_industrial: "",
          descricao_perfil_terreno: "",
          facilidade_escoamento_agua: "",
          destino_aguas_residuais: "",
          fontes_mau_cheiro: "",
          tipo_localizacao: "",
          tipo_pavimentacao_externa: ""
        },
        agua_abastecimento: [],
        instalacoes_industriais: [],
        maquinas_equipamentos: [],
        materias_primas: [],
        produtos_fabricar: [],
        funcionarios: [],
        processo_abate: "",
        barreiras_fisicas: "",
        observacoes: "",
        // Controls
        saved: false,
        deleted: false
      };

      this.formularios.push(formObj);
      this.activeIndex = this.formularios.length - 1;
    },
    onEditFormClick(formulario) {
      const index = this.formularios.findIndex(item =>
        item._id
          ? item._id === formulario._id
          : item.cod_formularios_mtse === formulario.cod_formularios_mtse
      );
      this.activeIndex = index;
    },
    onRemoveFormClick(formulario) {
      const index = this.formularios.findIndex(item =>
        item._id
          ? item._id === formulario._id
          : item.cod_formularios_mtse === formulario.cod_formularios_mtse
      );
      Swal.fire({
        title: "Deseja mesmo remover esse formulário MTSE?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#9b9b9b",
        cancelButtonColor: "#31813c",
        confirmButtonText: "Deletar!"
      }).then(result => {
        if (result.value) {
          if (formulario.id) {
            this.formularios[index].deleted = true;
          } else {
            this.formularios.splice(index, 1);
          }
        }
      });
    },
    closeModal(ev) {
      if (!this.formularios[this.activeIndex].saved) {
        this.formularios.splice(this.activeIndex, 1);
      }
      this.activeIndex = null;
    },
    onChangeForm(ev) {
      if (this.activeIndex !== null) {
        this.formularios[this.activeIndex] = ev;
      }
    }
  },
  mounted() {
    if (this.value && Array.isArray(this.value)) {
      this.formularios = this.value.map(form => {
        form.saved = true;
        form.deleted = false;
        return form;
      });
    }
  }
};
</script>
